(function () {
  'use strict';

  function getTabs() {
    return Array.prototype.slice.call(document.querySelectorAll('.horeca-tabs [data-horeca-tab]'));
  }

  function getCategories() {
    return Array.prototype.slice.call(document.querySelectorAll('.horeca-category[data-horeca-category]'));
  }

  function activateCategory(handle, updateHash) {
    if (!handle) return;
    var tabs = getTabs();
    var categories = getCategories();
    if (!tabs.length || !categories.length) return;

    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-horeca-tab') === handle;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    categories.forEach(function (section) {
      var active = section.getAttribute('data-horeca-category') === handle;
      section.hidden = !active;
      section.setAttribute('aria-hidden', active ? 'false' : 'true');
      section.style.display = active ? '' : 'none';
    });

    if (updateHash && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#horeca-' + handle);
    }
  }

  function initialHandle() {
    var hash = (window.location.hash || '').replace('#horeca-', '');
    var valid = getTabs().some(function (tab) {
      return tab.getAttribute('data-horeca-tab') === hash;
    });
    if (valid) return hash;
    var active = document.querySelector('.horeca-tabs [data-horeca-tab].is-active');
    return active ? active.getAttribute('data-horeca-tab') : 'floral';
  }

  function init() {
    activateCategory(initialHandle(), false);
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('.horeca-tabs [data-horeca-tab]');
    if (!tab) return;
    event.preventDefault();
    activateCategory(tab.getAttribute('data-horeca-tab'), true);
  }, true);

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('.horeca-tabs [data-horeca-tab]');
    if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
    var tabs = getTabs();
    var index = tabs.indexOf(tab);
    var next = event.key === 'ArrowRight' ? index + 1 : index - 1;
    if (next >= tabs.length) next = 0;
    if (next < 0) next = tabs.length - 1;
    tabs[next].focus();
    activateCategory(tabs[next].getAttribute('data-horeca-tab'), true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
